module.exports = __webpack_public_path__ + "img/TravelShip64_ua.8cd18b53.webp";